import { render, staticRenderFns } from "./headerPage.vue?vue&type=template&id=2f2b99d5&scoped=true&"
import script from "./headerPage.vue?vue&type=script&lang=js&"
export * from "./headerPage.vue?vue&type=script&lang=js&"
import style0 from "./headerPage.vue?vue&type=style&index=0&id=2f2b99d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b99d5",
  null
  
)

export default component.exports